import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges {
  @Input("name") name:any;
  @Input("data") gaTable:any;
  @Input("loading") tblLoading:any;
  @Input("tdh39Amendment") tdh39Amendment:boolean;

  showLoader:boolean = false;
 


  constructor() { }

  ngOnInit(): void {
  }
  ngOnChanges(changes:any):void {
    console.log(changes);
    if(changes?.tblLoading?.currentValue){
     this.showLoaderWithDelay();
    }
  }
  showLoaderWithDelay(){
    this.showLoader = true;
    setTimeout(()=> {
      this.showLoader = false;
    }, 800)

  }
}
